module.exports = __webpack_public_path__ + "static/img/menuBg.16473022.svg";